/**
 * @generated SignedSource<<9c0ace3b7afabe3116c88ab09f8a08c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentStatus = "CANCEL" | "INFO" | "PAID" | "PENDING";
export type PaymentType = "BANK_TRANSFER" | "CASH" | "PAYSERA";
export type AddPaymentInput = {
  amount: number;
  details?: string | null;
  paymentDate: string;
  status?: PaymentStatus | null;
  type: PaymentType;
};
export type OrderEditMainPaymentsTableAddMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
  payment: AddPaymentInput;
};
export type OrderEditMainPaymentsTableAddMutation$data = {
  readonly addPaymentToOrder: {
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"PaymentRow_payment">;
    } | null;
  } | null;
};
export type OrderEditMainPaymentsTableAddMutation = {
  response: OrderEditMainPaymentsTableAddMutation$data;
  variables: OrderEditMainPaymentsTableAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "payment"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "payment",
    "variableName": "payment"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrderEditMainPaymentsTableAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "PaymentMutationResult",
        "kind": "LinkedField",
        "name": "addPaymentToOrder",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Payment",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PaymentRow_payment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrderEditMainPaymentsTableAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "PaymentMutationResult",
        "kind": "LinkedField",
        "name": "addPaymentToOrder",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Payment",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paymentDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "details",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "amount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "PaymentEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3fd1f7c3eba178259595a4ed6402cbb7",
    "id": null,
    "metadata": {},
    "name": "OrderEditMainPaymentsTableAddMutation",
    "operationKind": "mutation",
    "text": "mutation OrderEditMainPaymentsTableAddMutation(\n  $id: ID!\n  $payment: AddPaymentInput!\n) {\n  addPaymentToOrder(id: $id, payment: $payment) {\n    node {\n      id\n      ...PaymentRow_payment\n    }\n  }\n}\n\nfragment PaymentRow_payment on Payment {\n  id\n  paymentDate\n  details\n  amount\n  createdAt\n  user {\n    name\n    id\n  }\n  ...PaymentType_payment\n  ...PaymentStatus_payment\n}\n\nfragment PaymentStatus_payment on Payment {\n  status\n}\n\nfragment PaymentType_payment on Payment {\n  type\n}\n"
  }
};
})();

(node as any).hash = "0eb57a276f62cae426b1e1bbe81de218";

export default node;
